// hooks/useValidateProductIds.js

import {useState, useCallback} from 'react'
import {validateProductIds} from '@/services/salesTargets'

export const useValidateProductIds = () => {
  const [isUpdating, setIsUpdating] = useState(false)
  const [validateProductIdsProgress, setValidateProductIdsProgress] = useState(0)
  const [validateProductIdsError, setValidateProductIdsError] = useState('')

  // Handles upload progress and updates progress state
  const onValidateProductIdsProgress = useCallback(progressEvent => {
    if (progressEvent.total) {
      const progressValue = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      setValidateProductIdsProgress(progressValue)
    }
  }, [])

  const simulateProgress = (setProgress, duration = 3000) => {
    const start = Date.now()
    const interval = setInterval(() => {
      const elapsed = Date.now() - start
      const progress = Math.min(100, Math.round((elapsed / duration) * 100))
      setProgress(progress)
      if (progress >= 100) clearInterval(interval)
    }, 100)
    return interval
  }

  // Validates product IDs with progress and error tracking
  const onValidateProductIds = (productIds, onCallback) => {
    setIsUpdating(true)
    setValidateProductIdsError('')
    const interval = simulateProgress(setValidateProductIdsProgress, 3000)
    return validateProductIds({data: productIds}, {onUploadProgress: onValidateProductIdsProgress})
      .then(response => {
        onCallback(response)
      })
      .catch(error => {
        const errMsg = error?.response?.data?.errorMessage || error?.message || 'An unknown error occurred'
        setValidateProductIdsError(errMsg)
        onCallback(error)
      })
      .finally(() => {
        clearInterval(interval)
        setIsUpdating(false)
        // Optional delay to show 100% progress before reset
        setTimeout(() => setValidateProductIdsProgress(0), 300)
      })
  }

  return {
    onValidateProductIds,
    isUpdating,
    validateProductIdsProgress,
    validateProductIdsError,
    setValidateProductIdsError,
  }
}
